import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import { GET_CONTACT_LIST, GET_USER_PROFILE, ADD_NEW_USER, DELETE_USER, UPDATE_USER, GET_CONTACT_LIST_DETAIL } from "./actionTypes"

import {
  getContactListsSuccess,
  getContactListsFail,
  getContactListDetailSuccess,
  getContactListDetailFail,
  // getUserProfileSuccess,
  // getUserProfileFail,
  // addUserFail,
  // addUserSuccess,
  // updateUserSuccess,
  // updateUserFail,
  // deleteUserSuccess,
  // deleteUserFail,
} from "./actions"

//Include Both Helper File with needed methods
import { getContactListData, getContactListDetailData } from "../../helpers/contact_list_helper"

// toast
import { toast } from "react-toastify";
// import 'react-toastify/dist/ReactToastify.css';

function* fetchContactLists({ payload }) {
  try {
    const response = yield call(getContactListData, payload);
    yield put(getContactListsSuccess(response))
  } catch (error) {
    yield put(getContactListsFail(error))
  }
}

function* fetchContactListDetail({ payload }) {
  try {
    const response = yield call(getContactListDetailData, payload);
    yield put(getContactListDetailSuccess(response))
  } catch (error) {
    yield put(getContactListDetailFail(error))
  }
}

// function* fetchUserProfile() {
//   try {
//     const response = yield call(getUserProfile)
//     yield put(getUserProfileSuccess(response))
//   } catch (error) {
//     yield put(getUserProfileFail(error))
//   }
// }

// function* onUpdateUser({ payload: user }) {
//   try {
//     const response = yield call(updateUser, user)
//     yield put(updateUserSuccess(response))
//     toast.success("Contact Updated Successfully", { autoClose: 2000 });
//   } catch (error) {
//     yield put(updateUserFail(error))
//     toast.error("Contact Updated Failed", { autoClose: 2000 });
//   }
// }

// function* onDeleteUser({ payload: user }) {
//   try {
//     const response = yield call(deleteUser, user)
//     yield put(deleteUserSuccess(response))
//     toast.success("Contact Deleted Successfully", { autoClose: 2000 });
//   } catch (error) {
//     yield put(deleteUserFail(error))
//     toast.error("Contact Deleted Failed", { autoClose: 2000 });
//   }
// }

// function* onAddNewUser({ payload: user }) {

//   try {
//     const response = yield call(addNewUser, user)
//     yield put(addUserSuccess(response))
//     toast.success("Contact Added Successfully", { autoClose: 2000 });
//   } catch (error) {
//     yield put(addUserFail(error))
//     toast.error("Contact Added Failed", { autoClose: 2000 });
//   }
// }

function* contactListsSaga() {
  yield takeEvery(GET_CONTACT_LIST, fetchContactLists)
  yield takeEvery(GET_CONTACT_LIST_DETAIL, fetchContactListDetail)
  // yield takeEvery(GET_USER_PROFILE, fetchUserProfile)
  // yield takeEvery(ADD_NEW_USER, onAddNewUser)
  // yield takeEvery(UPDATE_USER, onUpdateUser)
  // yield takeEvery(DELETE_USER, onDeleteUser)
}

export default contactListsSaga;
